import { removeLoadingState} from "../helpers";

export function initNotarySearch() {
    const searchForm = document.getElementById("notarySearchForm");
    const resultsContainer = document.getElementById("notaryResults");

    const notarySearchButton = document.getElementById("searchNotaryBtn");
    if (notarySearchButton) notarySearchButton.addEventListener("click", handleSearchClick)
    
    if (!searchForm || !resultsContainer) return;

    searchForm.addEventListener("sds:form:beforeSubmit", handleNotarySearch);
}

function handleSearchClick(e){
    e.preventDefault();
    window.dialog.open({  elemId: 'searchContainer', title: 'Zoek notariskantoor' });
}

async function handleNotarySearch(e) {
    e.preventDefault();
       
    const searchForm = e.currentTarget;
    const resultsContainer = document.getElementById("notaryResults");
    const formData = new URLSearchParams(new FormData(searchForm));

    try {
        const response = await fetch(searchForm.action, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData
        });

        resultsContainer.innerHTML = await response.text();

    } catch (error) {
        console.error("Error searching for notary:", error);
    } finally {
        searchForm.reset();
        removeLoadingState(e.submitter);
    }
}

